// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M3.5 2.5L20.5 2.5L20.5 21.5L3.5 21.5L3.5 2.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}},{"tag":"path","attrs":{"stroke":"#000","d":"M8 8H16M8 12H16M8 16H13","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"article"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3.5 2.5L20.5 2.5L20.5 21.5L3.5 21.5L3.5 2.5Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3.5 2.5L20.5 2.5L20.5 21.5L3.5 21.5L3.5 2.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8 8H16M8 12H16M8 16H13","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ArticleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'article',
    ref,
    icon: element,
  },
));

ArticleIcon.displayName = 'ArticleIcon';

export default ArticleIcon;
